(() => {
  let interactionTriggered = false;

  function hydrateVideo(wrapper) {
    if (!wrapper || wrapper.dataset.hydrated === 'true') return;

    const src = wrapper.dataset.videoSrc;
    if (!src) return;

    const video = document.createElement('video');
    video.preload = 'none';
    video.fetchpriority='high';
    video.autoplay = wrapper.dataset.autoplay === 'true';
    video.loop = wrapper.dataset.loop === 'true';
    video.muted = wrapper.dataset.muted === 'true';
    video.playsInline = wrapper.dataset.playsinline === 'true';
    if (wrapper.dataset.controls === 'true') video.controls = true;
    if (wrapper.dataset.poster) video.poster = wrapper.dataset.poster;

    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);

    wrapper.innerHTML = '';
    wrapper.appendChild(video);
    wrapper.dataset.hydrated = 'true';

    video.load();
    if (video.autoplay) {
      video.play().catch(() => {});
    }
  }

  function initDeferredVideos(scope = document, forceInstantOnly = false) {
    // If we only want instant-load elements, target them specifically; otherwise handle all remaining unhydrated items
    const selector = forceInstantOnly 
      ? '.js-deferred-video.instant-load:not([data-hydrated="true"])' 
      : '.js-deferred-video:not([data-hydrated="true"])';

    const wrappers = scope.querySelectorAll(selector);
    if (!wrappers.length) return;

    if (forceInstantOnly) {
      // Bypasses observers and user interaction requirements to mount instantly
      wrappers.forEach((wrapper) => hydrateVideo(wrapper));
    } else {
      // Use IntersectionObserver for standard elements after user interaction has occurred
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydrateVideo(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px' });

      wrappers.forEach((wrapper) => observer.observe(wrapper));
    }
  }

  // Trigger setup immediately upon real user interaction
  function triggerInteractivity() {
    if (interactionTriggered) return;
    interactionTriggered = true;

    // Remove event listeners once fired
    ['touchstart', 'mouseover', 'mousemove', 'scroll', 'keydown'].forEach((evt) => {
      window.removeEventListener(evt, triggerInteractivity, { passive: true });
    });

    // Initialize layout scanning safely outside the main initial thread window
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => initDeferredVideos(document, false), { timeout: 2000 });
    } else {
      setTimeout(() => initDeferredVideos(document, false), 50);
    }
  }

  // --- IMMEDIATE EXECUTION RUNTIME ---
  // Scan and inject 'instant-load' components as soon as the DOM tree renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDeferredVideos(document, true), { once: true });
  } else {
    initDeferredVideos(document, true);
  }

  // Listen to any baseline interaction events for standard lazy items
  ['touchstart', 'mouseover', 'mousemove', 'scroll', 'keydown'].forEach((evt) => {
    window.addEventListener(evt, triggerInteractivity, { once: true, passive: true });
  });

  // Ensure Shopify Theme Editor customization reloading still functions smoothly 
  document.addEventListener('shopify:section:load', (event) => {
    // Always check if the newly loaded section has any instant-load items first
    initDeferredVideos(event.target, true);

    if (interactionTriggered) {
      initDeferredVideos(event.target, false);
    } else {
      triggerInteractivity();
    }
  });
})();